import { render, staticRenderFns } from "./approvalTable.vue?vue&type=template&id=4d44c190"
import script from "./approvalTable.vue?vue&type=script&lang=js"
export * from "./approvalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports